export type LoginError = 'wrongCredentials' | 'notActivated' | 'unknown';

export const isEmail = (value: string) => /^\S+@\S+\.\S+$/.test(value);

/** Hva som gikk galt, ut fra svaret fra innloggingen */
export const loginError = (error: unknown): LoginError => {
  const { response } = error as { response?: { status?: number; data?: { errorCode?: string } } };
  if (response?.data?.errorCode === 'ACCOUNT_NOT_ACTIVATED') return 'notActivated';
  if (response?.status === 401) return 'wrongCredentials';
  return 'unknown';
};
